import { Record, Map } from "immutable";

const SitesStateRecord = Record({
  sites: Map(),
  loading: false,
  error: null,
  selectedSiteId: ""
});

export default SitesStateRecord;
